import { formatMapping, GROUPED_PLANNER_USER_WIDTH } from "../../../../lib/PlannerUtils";
import { getCellWidthForZoom, getNumberOfDays } from "../../../../lib/DateUtils";

class GroupedBookingsHelper {
  constructor(project, groupClients) {
    this.project = project;
    this.groupClients = groupClients;
  }

  startBookingResizing(e, booking, setIsDragging, setInitialPos, setInitialSize) {
    e.stopPropagation();
    setIsDragging(true);
    let resizable = document.getElementById(`booking-${booking.id}-${this.project.id}`);
    setInitialPos(e.clientY);
    setInitialSize(resizable.offsetHeight);
  }

  resizingBooking(e, booking, initialSize, numRound, initialPos, bookingFormat, calculateHeight) {
    e.stopPropagation();
    let resizable = document.getElementById(`booking-${booking.id}-${this.project.id}`);

    let newHeight =
      parseFloat(initialSize) + numRound(parseFloat(e.clientY - initialPos), formatMapping[bookingFormat] / 2);

    resizable.style.zIndex = 2;

    if (newHeight >= formatMapping[bookingFormat] / 2) {
      resizable.style.height = `${numRound(
        calculateHeight(((newHeight + 1) / formatMapping[bookingFormat]) * 60, booking.id, booking.date),
        formatMapping[bookingFormat] / 2
      )}px`;

      if (resizable.querySelector(".booking__project-duration")) {
        resizable.querySelector(".booking__project-duration").innerHTML =
          parseFloat(document.getElementById(`booking-${booking.id}-${this.project.id}`).style.height) /
            formatMapping[bookingFormat] +
          "h";
      }
    }
  }

  endBookingResizing(
    e,
    booking,
    numRound,
    bookingFormat,
    updateBookingsRequest,
    bookingsArray,
    getProject,
    setIsDragging
  ) {
    e.stopPropagation();
    let resizable = document.getElementById(`booking-${booking.id}-${this.project.id}`);
    let newDuration =
      numRound(parseFloat(resizable.style.height), formatMapping[bookingFormat] / 2) / formatMapping[bookingFormat];

    resizable.style.zIndex = 1;
    updateBookingsRequest(
      newDuration,
      booking.tentative,
      booking.location,
      booking.start_time,
      booking.comment,
      booking.using_budget,
      booking.grouping_id
        ? bookingsArray.filter((b) => b.grouping_id === booking.grouping_id).map((b) => b.id)
        : [booking.id],
      getProject(booking.project_id),
      booking.task_id
    );

    setIsDragging(false);
  }

  // eslint-disable-next-line no-unused-vars
  calculateLeftOffset(bookingDate, date, weekendsHidden, zoom, _user, _startTime) {
    let dateOffset = getNumberOfDays(date, bookingDate);
    let finalOffset = GROUPED_PLANNER_USER_WIDTH;
    const initialWeekDay = date.getDay();

    if (this.groupClients) {
      finalOffset += 50;
    }

    for (let i = 0; i < dateOffset; i++) {
      const weekday = (initialWeekDay + i) % 7;
      const isWeekend = weekendsHidden && (weekday === 0 || weekday === 6);

      if (i + 1 === dateOffset && weekendsHidden && weekday === 6) break;

      finalOffset += isWeekend ? 10 : getCellWidthForZoom(zoom);
    }

    return finalOffset;
  }
}

export default GroupedBookingsHelper;
